<div *ngIf="(externalTrigger || (active$ | async) === true) && !disabled" class="loading-overlay">
  <p-progressSpinner strokeWidth="1"></p-progressSpinner>
</div>
